import { useMediaQuery } from "@mui/material";
import { EditableDataGrid } from "../../../../builderPackage/components/editableDataGrid/editableDataGrid";
var correctiveActionsGrid = function (props) {
    var onChange = props.onChange, value = props.value, error = props.error, _a = props.name, name = _a === void 0 ? 'courierDetails' : _a;
    var currValue = value[name];
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var columns = [{
            type: 'string',
            field: 'Root cause 1',
            headerName: 'Root cause 1',
            width: 100,
            headerAlign: 'center',
            disableColumnMenu: true
        }, {
            field: 'Action taken 1',
            headerName: 'Action taken 1',
            width: 150,
            headerAlign: 'center',
            disableColumnMenu: true,
            editable: true
        }, {
            field: 'Dealer ID',
            headerName: 'Dealer ID',
            width: 120,
            headerAlign: 'center',
            editable: true
        }, {
            field: 'Root cause 2',
            headerName: 'Root cause 2',
            width: 170,
            headerAlign: 'center',
            disableColumnMenu: true
        }, {
            field: 'Action taken 2',
            headerName: 'Action taken 2',
            width: 170,
            headerAlign: 'center',
            disableColumnMenu: true
        }, {
            field: 'Root cause 3',
            headerName: 'Root cause 3',
            width: 170,
            headerAlign: 'center',
            disableColumnMenu: true
        }, {
            field: 'Action taken 3',
            headerName: 'Action taken 3',
            width: 170,
            headerAlign: 'center',
            disableColumnMenu: true
        }];
    return /*#__PURE__*/ React.createElement(EditableDataGrid, {
        disableAddRow: true,
        disableDeleteRow: false,
        isCollapsible: false,
        columns: columns,
        dataGridProps: {
            hideFooter: true
        },
        rows: currValue || [],
        onChange: onChange
    });
};
export default correctiveActionsGrid;
